import { z } from 'zod';

/**
 * Campos-base de TODO bloco `ChatUi`. O `id` identifica a instância do component
 * pra dedup na borda de render: a lista de uma mensagem exige ids únicos
 * (`ChatUiMessageSchema`), e o slot `header` mostra o último component por `id`
 * (latest-wins) — re-emitir o mesmo `id` ATUALIZA no lugar em vez de empilhar.
 * Os builders sempre setam um `id` estável por kind/conteúdo.
 */
export const chatUiBase = {
  id: z.string().min(1).max(64),
} as const;
